import React, { useEffect, useState } from "react";
import "./UpdateUserForm.css"; // External CSS file for styling
import { useSelector,useDispatch } from 'react-redux';
import { update_user } from "../features/userSlice";

const UpdateUserForm = () => {

  const { Info } = useSelector((state) => state.users);
  const [formData, setFormData] = useState({
    name: Info?.name,
    email: Info?.email,
    phone_number:Info?.phone_number,
    phonpe:Info?.phonepay,
    gpay:Info?.googlepay,
    paytm:Info?.paytm,
  });


  useEffect(()=>{
     if(Info?.phone_number){
        setFormData({
            name: Info?.name,
            email: Info?.email,
            phone_number:Info?.phone_number,
            phonpe:Info?.phonepay,
            gpay:Info?.googlepay,
            paytm:Info?.paytm,
          });
     }
  },[Info])

  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    }
    if(formData.phonpe?.trim()){
        if (!/^\d{10}$/.test(formData.phonpe)) {
        newErrors.phonpe = "phonePay number must be 10 digits.";
      }
    }
    if(formData.paytm?.trim()){
      if(!/^\d{10}$/.test(formData.paytm)) {
        newErrors.paytm = "paytm number must be 10 digits.";
      }
    }
    if(formData.gpay?.trim()){
      if(!/^\d{10}$/.test(formData.gpay)) {
        newErrors.gpay = "Google pay number must be 10 digits.";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
        var form_data_new = new FormData();

        for ( var key in formData ) {
            form_data_new.append(key, formData[key]);
        }
      dispatch(update_user(form_data_new));
    }
  };

  return (
    <div className="form-container payment-container">
      <h2>Update User Information</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <p className="error">{errors.name}</p>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="error">{errors.email}</p>}
        </div>

        <div className="form-group">
          <label htmlFor="mobile">Mobile Number</label>
          <input
            type="text"
            id="phone_number"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            readOnly={true}
          />
          {errors.mobile && <p className="error">{errors.mobile}</p>}
        </div>

        <div className="form-group">
          <label htmlFor="mobile">Phone Pay</label>
          <input
            type="text"
            id="phonpe"
            name="phonpe"
            value={formData.phonpe}
            onChange={handleChange}
          />
          {errors.phonpe && <p className="error">{errors.phonpe}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="mobile">G Pay</label>
          <input
            type="text"
            id="gpay"
            name="gpay"
            value={formData.gpay}
            onChange={handleChange}
          />
          {errors.gpay && <p className="error">{errors.gpay}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="mobile">paytm</label>
          <input
            type="text"
            id="paytm"
            name="paytm"
            value={formData.paytm}
            onChange={handleChange}
          />
          {errors.paytm && <p className="error">{errors.paytm}</p>}
        </div>

        <button type="submit" className="submit-btn">
          Update
        </button>
      </form>
    </div>
  );
};

export default UpdateUserForm;
